<template>
  <component
    :is="routeTo ? 'router-link' : 'div'"
    :id="id"
    v-touch-outside="showPromo"
    :to="routeTo"
    class="btn-promo-navbar"
    :class="checkWeekend ? 'add-padding-top' : ''"
    @click="onClick"
  >
    <div class="btn-promo-navbar__coat">
      <div class="btn-promo-navbar__coat__wrapper">
        <div
          id="text-content"
          class="btn-promo-navbar__coat__wrapper__text"
        >
          {{ text }}
        </div>
      </div>
    </div>
    <div
      v-if="checkWeekend"
      class="btn-promo-navbar__bubble-chat"
    >
      {{ checkWeekend }}
    </div>
  </component>
</template>

<script>
import mixinWeekend from "../../misc/mixinWeekend";

export default {
  name: "ButtonPromoNavbar",
  directives: {
    "touch-outside": {
      bind: function(el, binding, vnode) {
        el.touchOutsideEvent = function(event) {
          if (!(el == event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event);
          }
        };
        document.body.addEventListener("touchmove", el.touchOutsideEvent);
      },
      unbind: function(el) {
        document.body.removeEventListener("touchmove", el.touchOutsideEvent);
      },
    },
  },
  mixins: [mixinWeekend],
  props: {
    routeTo: {
      type: Object,
      default: null,
    },
    text: {
      type: String,
      default: "Button",
    },
    id: {
      type: String,
      default: "ButtonId",
    },
  },
  data() {
    return {
      promoShowed: true,
      textShowed: false,
    }
  },
  methods: {
    onClick(event) {
      if (!this.disabled) {
        this.$emit('click', event)
      }
    },
    showPromo() {
      this.promoShowed = true
      this.textShowed = false
    },
    showText() {
      this.promoShowed = false
      this.textShowed = true
    },
  }
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
